import React, { useEffect } from "react";
import "./css/splash.css"; // 새 CSS 분리 (아래 제공)
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

export default function Splash() {
    const navigate = useNavigate();

    useEffect(() => {
        const t = setTimeout(() => navigate("/login", { replace: true }), 4000);
        return () => clearTimeout(t);
    }, [navigate]);

    return (
        <div className="container-wrap">
            {/* BG Video */}
            <video
                className="splash-bg"
                autoPlay
                loop
                muted
                playsInline
            >
                <source src="/videos/winter_splash.mp4" type="video/mp4" />
            </video>

            {/* 카피 */}
            <div className="splash-copy">
                <p className="splash-eyebrow">의료선교네트워크</p>
                <h1 className="splash-title">모바일 신분증</h1>
                <h2 className="splash-subtitle">확인서비스</h2>
            </div>

            {/* <div style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            }}>
                <ClipLoader
                    color="#ff6a63"
                    size={70}
                    cssOverride={{ borderWidth: "4px", marginBottom: "0px" }}
                    speedMultiplier={0.3}
                />
            </div> */}

            {/* 하단 로고/문구 */}
            <div className="splash-logos">
                <img src="/img/myCert.png" style={{
                    width: "120px"
                }} />
            </div>
        </div>
    );
}
